import { useEffect, useMemo, useState } from "react";
import { sendFetchRequest } from "@/utils/sendFetchRequest";
import { CompanyRate } from "@/interfaces/searchBlock/companyRate";

type RequestError = {
  status: number;
  title: string;
};

export const useFetchCompanyRate = (code: string | undefined) => {
  const [companyRate, setCompanyRate] = useState<CompanyRate | undefined>(
    undefined
  );
  const [isError, setIsError] = useState<RequestError | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (code === undefined || code === "") {
      setCompanyRate(undefined);
      setIsError(undefined);
      setIsLoading(false);

      return;
    }

    setIsLoading(true);
    sendFetchRequest(`/price/v1/companyRateCode/${code}`)
      .then((response: CompanyRate) => {
        setCompanyRate(response);
        setIsLoading(false);
      })
      .catch((e: RequestError) => {
        setCompanyRate(undefined);
        setIsError(e);
        setIsLoading(false);
      });
  }, [code]);

  const fetchResult = useMemo(
    () => ({
      companyRate: companyRate,
      error: isError,
      isLoading: isLoading,
    }),
    [companyRate, isError, isLoading]
  );

  return fetchResult;
};
